import React from 'react';
import axios from 'axios';
import './App.css';
import { BASE_URL_TRUSTNET } from './api';
import { Strings } from './Strings';

function Register(props) {
  const [value, setValue] = React.useState({
    email: '',
    name: '',
    phone: '',
    username: '',
  });
  const [loading, setLoading] = React.useState(false);
  const [redirect, setRedirect] = React.useState(false);
  const [error, setError] = React.useState(false);

  const handlePress = async () => {
    setLoading(true);
    try {
      let res = await axios.post(`${BASE_URL_TRUSTNET}/registerUser`, {
        email: value.email,
        username: value.username,
        phone: value.phone,
        name: value.name,
        appId: props.appId,
      });
      if (!res.data.success) {
        setError(res.data.message);
      } else {
        setRedirect(true);
        setTimeout(() => {
          props.setCurrentRoute('login');
        }, 3000);
        setError(false);
      }
    } catch (err) {
      console.log('errr', err);
    }
    setLoading(false);
  };
  const handleChange = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };
  // Publish a message to the test channel
  if (redirect) {
    return (
      <div>
        <p>{Strings.REGISTER_SUCCESSFULLY}</p>
      </div>
    );
  }
  return (
    <div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <input
        name='email'
        value={value.email}
        onChange={handleChange}
        placeholder={Strings.EMAIL_ADDRESS}
      />

      <input
        name='name'
        value={value.name}
        onChange={handleChange}
        placeholder={Strings.FULL_NAME}
      />

      <input
        name='username'
        value={value.username}
        onChange={handleChange}
        placeholder={Strings.USERNAME}
      />

      <input
        name='phone'
        value={value.phone}
        onChange={handleChange}
        placeholder={Strings.PHONE_NUMBER}
      />
      <button onClick={handlePress}>
        {loading ? Strings.LOADING : Strings.REGISTER}
      </button>
    </div>
  );
}

export default Register;
